import {
  AssociatedProperty,
  IAssociatedProperty,
} from '@app/models/AssociatedProperty'
import {
  IIndividualAmount,
  IndividualAmount,
} from '@app/models/IndividualAmount'
import { List, Record } from 'immutable'

export interface IEarningSummaryItem {
  readonly brokerName: string
  readonly property: IAssociatedProperty
  readonly closingDate: number
  readonly saleLeasePrice: number
  readonly buyerTenant: string
  readonly totalCommission: number
  readonly listingFeePercent: number
  readonly listingAgentAmounts: List<IIndividualAmount>
  readonly sellingFeePercent: number
  readonly sellingAgentAmounts: List<IIndividualAmount>
}

const EarningSummaryItemRecord = Record({
  brokerName: '',
  buyerTenant: '',
  closingDate: 0,
  listingAgentAmounts: List<IndividualAmount>(),
  listingFeePercent: 0,
  property: undefined,
  saleLeasePrice: 0,
  sellingAgentAmounts: List<IndividualAmount>(),
  sellingFeePercent: 0,
  totalCommission: 0,
})

export class EarningSummaryItem
  extends EarningSummaryItemRecord
  implements IEarningSummaryItem
{
  public static fromJS(initialState?: Partial<IEarningSummaryItem>) {
    if (!initialState) {
      return new EarningSummaryItem()
    }

    const { property, listingAgentAmounts, sellingAgentAmounts, ...rest } =
      initialState

    return new EarningSummaryItem({
      listingAgentAmounts: listingAgentAmounts
        ? List(listingAgentAmounts.map((a) => IndividualAmount.fromJS(a)))
        : undefined,
      property: property ? AssociatedProperty.fromJS(property) : undefined,
      sellingAgentAmounts: sellingAgentAmounts
        ? List(sellingAgentAmounts.map((a) => IndividualAmount.fromJS(a)))
        : undefined,
      ...rest,
    })
  }

  public readonly brokerName: string
  public readonly property: IAssociatedProperty
  public readonly closingDate: number
  public readonly saleLeasePrice: number
  public readonly buyerTenant: string
  public readonly totalCommission: number
  public readonly listingFeePercent: number
  public readonly listingAgentAmounts: List<IIndividualAmount>
  public readonly sellingFeePercent: number
  public readonly sellingAgentAmounts: List<IIndividualAmount>

  constructor(initialState?: Partial<EarningSummaryItem>) {
    initialState ? super(initialState) : super()
  }
}
